import type { InterventionFollowupDropdownPopupProps } from "./intervention-followup-dropdown-popup.type";

import { Button, Tooltip } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { BUTTON_TYPE } from "@/constants/Button";
import { useSidePanel } from "@/modules/side-panel";

import { InterventionFollowupForm } from "../intervention-followup-form";

export const InterventionFollowupDropdownPopup = ({
  intervention,
  menu,
}: InterventionFollowupDropdownPopupProps) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const isDisabled = !intervention.is_followup_allowed;

  const handleCreateFollowUp = useCallback(() => {
    openSidePanel({
      title: t("followUp:header"),
      component: <InterventionFollowupForm intervention={intervention} />,
    });
  }, [openSidePanel, intervention, t]);

  return (
    <div className="follow-up-dropdown-wrapper">
      <Tooltip
        title={
          isDisabled ? t("intervention:followUp.button.disabled") : undefined
        }
        placement="leftTop"
      >
        <div className="new-follow-up">
          <Button
            block
            type={BUTTON_TYPE.TEXT}
            disabled={isDisabled}
            onClick={handleCreateFollowUp}
          >
            {t("followUp:new")}
          </Button>
        </div>
      </Tooltip>
      <div className="header-follow-up-button-dropdown">{menu}</div>
    </div>
  );
};
